import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { forgotPassword, verifyOTPforForget } from "../api/apis";
import OtpEnter from "../Pages/OtpEnter";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [otpMenuToggle, setOtpMenuToggle] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // FontAwesome CDN injection removed as it is no longer needed.
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Invalid email format";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        const response = await forgotPassword({ email });
        if (response.data.success) {
          toast.success("OTP sent to your email");
          setOtpMenuToggle(true);
        } else {
          toast.error(response.data.message || "Failed to send OTP");
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("An error occurred. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const handleOtpSubmit = async (otp) => {
    try {
      console.log("Verifying OTP:", { email, otp });
      const response = await verifyOTPforForget({ email, otp });
      
      console.log("OTP verification response:", response);
      
      if (response.data.success === true || response.data.verify === true) {
        toast.success("OTP verified successfully");
        navigate("/reset-password", { state: { email, verified: true } });
      } else {
        toast.error(response.data.message || "Invalid OTP");
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred. Please try again.");
      }
    }
  };

  const handleResendOtp = async () => {
    try {
      const response = await forgotPassword({ email });
      if (response.data.success) {
        return response;
      } else {
        throw new Error(response.data.message || "Failed to resend OTP");
      }
    } catch (error) {
      throw error;
    }
  };

  return (
    otpMenuToggle ? (
      <OtpEnter
        setOtpMenuToggle={setOtpMenuToggle}
        emailId={email}
        type="reset"
        onSubmit={handleOtpSubmit}
        showPasswordField={false}
        onSuccess={() => navigate("/reset-password", { state: { email, verified: true } })}
        onResendOtp={handleResendOtp}
      />
    ) : (
      <div className="fullscreen-container">
        <div className="card w-full max-w-md p-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold">Forgot Password</h1>
            <p className="text-brand-muted mt-2">Enter your email to receive a reset code.</p>
          </div>
          <form className="space-y-4 mt-8" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="sr-only">Email Address</label>
              <input
                id="email"
                type="email"
                className={`input-field ${errors.email ? "border-red-500/50" : ""}`}
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && <p className="error-message">{errors.email}</p>}
            </div>
            <button
              type="submit"
              className="btn btn-primary w-full"
              disabled={loading}
            >
              {loading ? "Sending Code..." : "Send Reset Code"}
            </button>
          </form>
          <p className="text-center text-brand-muted text-sm mt-6">
            Remember your password?{' '}
            <Link to="/login" className="font-semibold text-brand-yellow hover:underline">Sign in</Link>
          </p>
        </div>
      </div>
    )
  );
};

export default ForgotPassword; 